
<div *ngIf="loaderEnabled" class="loader-outer">
  <div class="loader"></div>
</div>

